import React from 'react';
import '../../components/Header/Header.css';

const Header = ({ msisdn }) => {
  return (
    <header className="header text-white d-flex justify-content-between align-items-center py-3">
      <img src="/images/webdoc-white.webp" alt="Logo" className="main-logo p-3 mb-0" />
      <h5 className="mb-0 p-3 msisdn-text">{msisdn}</h5>
    </header>
  );
};


export default Header;
